<template>
  <hr class="tw-border-primary-grey-100" :class="sizeClass" />
</template>

<script lang="ts" setup>
import { computed } from "vue";

const props = withDefaults(
  defineProps<{
    size?: "lg" | "md";
  }>(),
  {
    size: "lg",
  },
);

const sizeClass = computed(() => (props.size === "lg" ? "tw-my-6" : "tw-my-4"));
</script>
